<!-- 企业级-授权管理-设备中心-设备位置地图 -->
<template>
  <div class="CDeviceMap">
      <div id="l-map"></div>
  </div>
</template>

<script>
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { deviceApi } from "../../../../static/js/api.js"

  export default {
    name: 'CDeviceMap',
    props:['device_no_id'],
    data() {
      return {
        locationList:[],
        activeIndex: 0
      }
    },
    created () {
    },
    mounted(){
      console.log('device_no_id', this.device_no_id)
      // this.init()
      this.getDeviceLocation()
    },
    methods: {
      // 获取设备位置
      async getDeviceLocation() {
        let vm = this
        let data = {
          device_no_id: this.device_no_id
        }
        console.log('data', data)
        let res = await deviceApi.getDeviceLocation(data)
        if (res.meta.code == 200) {
          let list = [...res.data]
          for (let i in list) {
            let adds = new BMap.Point(list[i].longitude, list[i].latitude)
            list[i].adds = adds
            if (list[i].device_no_id == vm.device_no_id) {
              vm.activeIndex = i
            }
          }
          vm.locationList = [...list]
          console.log('locationList::::', vm.locationList)
          vm.init()
        } else {
          showToast(res.meta.message)
        }
      },
      // 初始化地图
      init () {
        let vm = this
        let activeAdds = vm.locationList[vm.activeIndex].adds
        console.log('activeAdds::', activeAdds)
        let map = new BMap.Map("l-map")
        map.centerAndZoom(activeAdds, 13)
        map.enableScrollWheelZoom(true)  //开启鼠标滚轮缩放
        let myGeo = new BMap.Geocoder()
        let locationList = [...this.locationList]
        locationList.forEach(function (item, i) {
          // 逆解析地理位置
          let pt = item.adds
          myGeo.getLocation(pt, function (rs) {
            let addComp = rs.addressComponents
            console.log('rs', rs)
            let space_name= addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber
            locationList[i].space_name = space_name
            vm.$emit('getActiveInfo', vm.locationList[vm.activeIndex].space_name)

            // 设置新icon
            vm.setIcon(map, locationList[i])
          })
        })
        // vm.openInfo()
      },
      // 设置icon
      setIcon (map, item) {
        let vm = this
        let myIcon = new BMap.Icon('../../static/images/site_icon.png', new BMap.Size(24,24))
        let marker = new BMap.Marker(item.adds, {icon: myIcon})  // 创建标注
        marker.disableMassClear()
        map.addOverlay(marker)    // 将标注添加到地图中
        
        // vm.openInfo( map, marker, item)
        
        if (item.isNow) { vm.openInfo2( map, marker, item) }
        vm.addClickHandler(map, marker, item)
       
      },
      // 隐藏标注
      hideLable (map, showLabel) {
        let vm = this
        // var showLabel = '<div class="go"><p class="infoW-name">' + item.space_name + '</p></div>'
        var allOverlay = map.getOverlays()
        console.log('allOverlay', allOverlay)
        for (var i = 1; i < allOverlay.length; i++){
          // console.log('allOverlay[i].getLabel().content', allOverlay[i].getLabel().content)
          // if(allOverlay[i].getLabel().content == la){
            console.log('getPosition', allOverlay[i].getPosition())
            if (allOverlay[i].getPosition() == null) {
              return
            }
          let active
          if(allOverlay[i].getPosition().lng == showLabel.lng && allOverlay[i].getPosition().lat == showLabel.lat){
            active = i
            // return false;
          }
          map.removeOverlay(allOverlay[i])
          map.addOverlay(allOverlay[i])
          if (active == i) {
            console.log('i', i)
            console.log('vm.locationList[i]', vm.locationList[i])
            vm.openInfo( map, allOverlay[i], vm.locationList[i])
          }
        }
      },
      // 开启信息窗口
      openInfo(map, marker, item) {
        // 自定义弹窗地址
        let labelText = '<div class="go"><p class="infoW-name">' + item.space_name + '</p></div>'
        let label = new BMap.Label(labelText, {offset: new BMap.Size(12, -83)})
        // label.enableMassClear()
        label.setStyle({
          textAlign: 'center',
          border: 'none',
          fontSize : '18px',
          lineHeight : '1',
          borderRadius: '5px',
          fontFamily: "微软雅黑",
          display: item.isNow ? 'block' : 'none'
        })
        marker.setLabel(label)

         marker.addEventListener("click",function(e){
          console.log('e', e)
          this.locationList.forEach(function (lItem, i) {
            label.setStyle({
              display: 'block'
            })
            if (i = 1) {

            label.setStyle({
              display: 'none'
            })
            }
          })
        })


      },
      addClickHandler(map, marker, item){
        let vm = this
        marker.addEventListener("click",function(e){
          console.log('e::', e)
          vm.openInfo2( map, marker, item)
          })
      },
      // 开启信息窗口
      openInfo2(map, marker, item){
        var opts = {    
            width : 200,     // 信息窗口宽度    
            height: 60,     // 信息窗口高度 
        }
        let html = '<div class="go"><p class="infoW-name">' + item.space_name + '</p></div>'
        var infoWindow = new BMap.InfoWindow(html, opts);  // 创建信息窗口对象
        var point = new BMap.Point(item.longitude, item.latitude)
        map.openInfoWindow(infoWindow, point);      // 打开信息窗口
        // var opts = {
        //   width : 250,     // 信息窗口宽度
        //   height: 80,     // 信息窗口高度
        //   title : "信息窗口" , // 信息窗口标题
        //   enableMessage:true//设置允许信息窗发送短息
			  //  };
        // var p = e.target;
        // var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
        // var infoWindow = new BMap.InfoWindow(content, opts);  // 创建信息窗口对象 
        // map.openInfoWindow(infoWindow,point); //开启信息窗口
      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      },
    }
  }
</script>

<style lang="scss">
  .CDeviceMap {
    #l-map {
      width: 100%;
      height: 500px;
      // 地图信息窗口
      .BMapLabel {
        transform: translateX(-50%);
        box-shadow: 10px 10px 10px #b1afb0;
        top: -58px !important;
        .go {
          // display: block;
          padding: 10px 24px 12px;
          color: #999999;
          .infoW-total {
            margin-top: 8px;
            color: #096cf1;
          }
        }
      }
      .BMapLabel::after {
        content: '';
        display:block;
        width: 0;
        height: 0;
        border-width: 13px 6.5px 0;
        border-style: solid;
        border-color: #ffffff transparent transparent;/*透明 透明  黄*/
        transform: translateX(-50%);
        position: absolute;
        left: 50%;
        bottom: -13px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ExpPage/CSceneManage/CDeviceMap.vue